import { rewordValidationMessages } from '#api/errors.ts';
import type { FeatureFlags } from '#dn-types/org.ts';
import { del, get, patch } from './fetch.ts';

// GET /feature-flags
export type FeatureFlagsResult = Partial<FeatureFlags>; // Partial, because we need to handle cases where the api does not yet support the flag
export async function getFeatureFlags(init?: RequestInit) {
  return get<FeatureFlagsResult>('/v1/feature-flags', init).then((res) => res.data);
}

// GET /deployment-feature-flags (unauthenticated — returns deployment-wide defaults)
export async function getDeploymentFeatureFlags(init?: RequestInit) {
  return get<FeatureFlagsResult>('/v1/deployment-feature-flags', init).then((res) => res.data);
}

// PATCH /v1/organizations/{orgID}
export type RenameOrgResult = { id: string; name: string; createdAt: string; subscriptionStatus: string };
export function renameOrg({ orgId, name }: { orgId: string; name: string }) {
  return patch<RenameOrgResult>(`/v1/organizations/${encodeURIComponent(orgId)}`, { name });
}

type DeleteOrgResult = Record<string, never>;
export function deleteOrg(orgId: string) {
  return del<DeleteOrgResult>(`/v1/organizations/${encodeURIComponent(orgId)}`).catch((err: unknown) => {
    rewordValidationMessages(err, (details) => {
      if (details.path === undefined && details.code === 'ERR_BILLING_INVALID_STATE') {
        return 'Please downgrade to the Free plan before deleting your account.';
      }
    });
  });
}
